import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { MensajesService } from './../../services/mensajes.service';
import { UsuariosService } from './../../services/usuarios.service';
import { ActivatedRoute } from '@angular/router';
import { IntervinientesService } from './../../services/intervinientes.service';
import { Component, OnInit, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styles: [`
    .ng-invalid.ng-dirty:not(form){
      border:1px solid red;
    }
    .ng-submitted .ng-invalid:not(form){
      border:1px solid red;
    }
  `]
})
export class UsuarioComponent implements OnInit {

  @ViewChild ("mensajeUsuario") mensajeUsuario:ElementRef;
  @ViewChild ("formulario") formulario:ElementRef;
  @ViewChild ("mensajeRecuperar") mensajeRecuperar:ElementRef;
  @ViewChild ("formulario2") formulario2: ElementRef;
  @ViewChild ("modalpass") modalpass:ElementRef;
  @ViewChild ("botonCerrar") botonCerrar:ElementRef;
  codigo;
  usuario={};
  textomensaje;
  
  usuarioPass={
    USpassword:"",
    nextPass:"",
    nextPass2:""
  };

  activo:boolean;

  mensajesEnviados;
  mensajesRecibidos;

  paginaActualRecibidos:number=1;
  paginaSiguienteRecibidos:number;
  paginaAnteriorRecibidos:number;
  totalPaginasRecibidos:number;
  paginaActualEnviados:number=1;
  paginaSiguienteEnviados:number;
  paginaAnteriorEnviados:number;
  totalPaginasEnviados:number;

  constructor(private intervinientesService:IntervinientesService, private activatedRoute:ActivatedRoute,
              private usuariosService:UsuariosService, private mensajesService:MensajesService,
              private renderer:Renderer2, private location:Location, private auth:AuthService) {

    this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];
    });
    this.usuario={UScif:""};
   }

  ngOnInit() {
    this.usuariosService.getPerfilesUsuario().subscribe();

    if(this.codigo!="nuevo"){
      this.cargarUsuario();
    }
  }

  cargarUsuario(){
    this.usuariosService.getUsuario(this.codigo)
    .subscribe(resp=>{
      this.usuario=resp["usuario"];
      this.usuario["USactivo"]==1?this.activo=true:this.activo=false;
    });
  }

  guardarUsuario(myform:NgForm){
    
    this.renderer.addClass(this.formulario.nativeElement, "ng-submitted");
    
      if(this.codigo=="nuevo"){
        this.insertarUsuario();
      }else{
        this.updateUsuario();
      }
  }

  insertarUsuario(){
    this.activo==true?this.usuario["USactivo"]=1:this.usuario["USactivo"]=0;
    this.usuariosService.insertUsuario(this.usuario)
    .subscribe(response=>{
      let texto=this.renderer.createText(response["msg"]);
      if(response["err"]==false){
        this.renderer.setStyle(this.mensajeUsuario.nativeElement,"color", "green");
      }else{
        this.renderer.setStyle(this.mensajeUsuario.nativeElement,"color", "red");
      }
      this.renderer.appendChild(this.mensajeUsuario.nativeElement,texto);
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeUsuario.nativeElement,texto);
        if(response["err"]==false){
          this.location.back();
        }
      }, 2000);

    })
  }

  updateUsuario(){
    this.activo==true?this.usuario["USactivo"]=1:this.usuario["USactivo"]=0;
    this.usuariosService.updateUsuario(this.usuario)
    .subscribe(response=>{
      let texto=this.renderer.createText(response["msg"]);
      if(response["err"]==false){
        this.renderer.setStyle(this.mensajeUsuario.nativeElement,"color", "green");
      }else{
        this.renderer.setStyle(this.mensajeUsuario.nativeElement,"color", "red");
      }
      this.renderer.appendChild(this.mensajeUsuario.nativeElement,texto);
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeUsuario.nativeElement,texto);
        
      }, 2000);
    })
  }

  reiniciarUsuario(){
    this.cargarUsuario();
  }

  volver(){
    this.location.back();
  }

  guardarNuevaPass(myform:NgForm){
    
    this.renderer.addClass(this.formulario2.nativeElement, "ng-submitted");

    if(myform.valid){
      if(this.usuarioPass["nextPass"]==this.usuarioPass["nextPass2"]){
        this.usuarioPass["UScodigo"]=this.usuario["UScodigo"];
        this.usuariosService.cambiarPass(this.usuarioPass)
        .subscribe(resp=>{
          
          if(resp["err"]==false){
            this.textomensaje=this.renderer.createText("Contraseña actualizada.");
            this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-success");
          }else{
            this.textomensaje=this.renderer.createText(resp["msg"]);
            this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-danger");
          }
          this.renderer.appendChild(this.mensajeRecuperar.nativeElement, this.textomensaje);
        });
      
      }else{
        this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-danger");
        this.textomensaje=this.renderer.createText("La contraseña repetida no coincide con la nueva contraseña.");
        this.renderer.appendChild(this.mensajeRecuperar.nativeElement, this.textomensaje);
      }
    }else{
      this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-danger");
      this.textomensaje=this.renderer.createText("Hay errores en el formulario.");
      this.renderer.appendChild(this.mensajeRecuperar.nativeElement, this.textomensaje);
    }
    
    setTimeout(() => {
      this.renderer.removeChild(this.mensajeRecuperar.nativeElement, this.textomensaje);
    }, 3000);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/usuario/usuario.component.ts